import { Icon, Typography } from '@design-system';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import './Pagination.scss';
import { usePagination } from './usePagination';

export type PaginationProps = {
    currentPage: number;
    numPages: number;
    setCurrentPage: (page: number) => void;
};

export const Pagination: React.FC<PaginationProps> = ({ currentPage, numPages, setCurrentPage }) => {
    const { handlePreviousPage, handleNextPage } = usePagination({ currentPage, numPages, setCurrentPage });

    return (
        <div className="pagination">
            <div className={`previous ${currentPage === 1 ? 'disabled' : ''}`} onClick={handlePreviousPage}>
                <Icon icon={<MdKeyboardArrowLeft />} size={24} />
            </div>
            <div className="current">
                <Typography intrinsic="p">
                    {currentPage} sur {numPages}
                </Typography>
            </div>
            <div className={`next ${currentPage === numPages ? 'disabled' : ''}`} onClick={handleNextPage}>
                <Icon icon={<MdKeyboardArrowRight />} size={24} />
            </div>
        </div>
    );
};
